//#region src/transactions/intents/BalanceIntentNames.ts
const ALLOWANCE_BALANCE = "AllowanceBalance";
const COIN_WITH_BALANCE = "CoinWithBalance";
//#endregion
export { ALLOWANCE_BALANCE, COIN_WITH_BALANCE };

//# sourceMappingURL=BalanceIntentNames.mjs.map